// Generated by shared-icons/sync-icons.js. Do not edit directly.

export type NogoshIconName =
  | 'auth.android'
  | 'auth.apple'
  | 'auth.facebook'
  | 'auth.google'
  | 'auth.login'
  | 'auth.logout'
  | 'auth.password'
  | 'chat.automation'
  | 'chat.chat'
  | 'chat.send'
  | 'common.back'
  | 'common.check'
  | 'common.chevronDown'
  | 'common.chevronLeft'
  | 'common.chevronRight'
  | 'common.close'
  | 'common.delete'
  | 'common.download'
  | 'common.edit'
  | 'common.error'
  | 'common.externalLink'
  | 'common.info'
  | 'common.loading'
  | 'common.minus'
  | 'common.more'
  | 'common.plus'
  | 'common.question'
  | 'common.refresh'
  | 'common.save'
  | 'common.search'
  | 'common.selected'
  | 'common.share'
  | 'common.target'
  | 'common.text'
  | 'common.unselected'
  | 'common.warning'
  | 'locations.contact'
  | 'locations.directions'
  | 'locations.distance'
  | 'locations.hours'
  | 'locations.list'
  | 'locations.location'
  | 'locations.map'
  | 'locations.mine'
  | 'locations.search'
  | 'locations.website'
  | 'match.addPlayers'
  | 'match.balanceTeams'
  | 'match.cancel'
  | 'match.chevronForward'
  | 'match.editPlayers'
  | 'match.editResult'
  | 'match.history'
  | 'match.infinity'
  | 'match.inviteDirect'
  | 'match.inviteEmail'
  | 'match.inviteFriends'
  | 'match.inviteGuest'
  | 'match.inviteLink'
  | 'match.maxPlayers'
  | 'match.notifications'
  | 'match.notify.noResponse'
  | 'match.notify.reserve'
  | 'match.notify.sosContacts'
  | 'match.notify.sosOther'
  | 'match.rating'
  | 'match.recurring'
  | 'match.rulebook'
  | 'match.seasons'
  | 'match.settings'
  | 'match.sliders'
  | 'match.soccer'
  | 'match.sos'
  | 'match.stats'
  | 'match.status.declined'
  | 'match.status.firstTeam'
  | 'match.status.notAnswered'
  | 'match.status.notNotified'
  | 'match.time'
  | 'match.uncancel'
  | 'match.visibility'
  | 'match.visibilityOpen'
  | 'navigation.chat'
  | 'navigation.matches'
  | 'navigation.more'
  | 'navigation.notifications'
  | 'notifications.readAll'
  | 'notifications.type.candidateRequest'
  | 'notifications.type.emailVerification'
  | 'notifications.type.lowPlayerCount'
  | 'notifications.type.matchCanceled'
  | 'notifications.type.matchFull'
  | 'notifications.type.matchInvite'
  | 'notifications.type.matchLocationChanged'
  | 'notifications.type.matchResponseReminder'
  | 'notifications.type.matchTimeChanged'
  | 'notifications.type.missingResult'
  | 'notifications.type.noActiveMatches'
  | 'notifications.type.pendingInvites'
  | 'notifications.type.profileLocationMissing'
  | 'notifications.type.publicRsvp'
  | 'notifications.type.ratingReview'
  | 'notifications.type.rulebookReminder'
  | 'notifications.type.sosRecommended'
  | 'player.add'
  | 'player.addressCard'
  | 'player.camera'
  | 'player.claim'
  | 'player.email'
  | 'player.image'
  | 'player.notifications'
  | 'player.phone'
  | 'player.profile'
  | 'player.rating'
  | 'player.security'
  | 'player.team'
  | 'player.unavailable'
  | 'publicInvite.chat'
  | 'publicInvite.profileNudge';

export type NogoshIconSizeName =
  | 'button'
  | 'compact'
  | 'emptyState'
  | 'inline'
  | 'micro'
  | 'prominent'
  | 'row'
  | 'state'
  | 'toolbar';

export interface NogoshIconDefinition {
  family: 'fontawesome5';
  fontAwesome5: string;
  style: 'solid' | 'regular' | 'brand';
  className: string;
}

export const NOGOSH_ICONS: Record<NogoshIconName, NogoshIconDefinition> = {
  'auth.android': {
    'className': 'fab fa-android',
    'family': 'fontawesome5',
    'fontAwesome5': 'android',
    'style': 'brand',
  },
  'auth.apple': {
    'className': 'fab fa-apple',
    'family': 'fontawesome5',
    'fontAwesome5': 'apple',
    'style': 'brand',
  },
  'auth.facebook': {
    'className': 'fab fa-facebook',
    'family': 'fontawesome5',
    'fontAwesome5': 'facebook',
    'style': 'brand',
  },
  'auth.google': {
    'className': 'fab fa-google',
    'family': 'fontawesome5',
    'fontAwesome5': 'google',
    'style': 'brand',
  },
  'auth.login': {
    'className': 'fas fa-sign-in-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'sign-in-alt',
    'style': 'solid',
  },
  'auth.logout': {
    'className': 'fas fa-sign-out-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'sign-out-alt',
    'style': 'solid',
  },
  'auth.password': {
    'className': 'fas fa-key',
    'family': 'fontawesome5',
    'fontAwesome5': 'key',
    'style': 'solid',
  },
  'chat.automation': {
    'className': 'fas fa-robot',
    'family': 'fontawesome5',
    'fontAwesome5': 'robot',
    'style': 'solid',
  },
  'chat.chat': {
    'className': 'fas fa-comments',
    'family': 'fontawesome5',
    'fontAwesome5': 'comments',
    'style': 'solid',
  },
  'chat.send': {
    'className': 'fas fa-paper-plane',
    'family': 'fontawesome5',
    'fontAwesome5': 'paper-plane',
    'style': 'solid',
  },
  'common.back': {
    'className': 'fas fa-arrow-left',
    'family': 'fontawesome5',
    'fontAwesome5': 'arrow-left',
    'style': 'solid',
  },
  'common.check': {
    'className': 'fas fa-check',
    'family': 'fontawesome5',
    'fontAwesome5': 'check',
    'style': 'solid',
  },
  'common.chevronDown': {
    'className': 'fas fa-chevron-down',
    'family': 'fontawesome5',
    'fontAwesome5': 'chevron-down',
    'style': 'solid',
  },
  'common.chevronLeft': {
    'className': 'fas fa-chevron-left',
    'family': 'fontawesome5',
    'fontAwesome5': 'chevron-left',
    'style': 'solid',
  },
  'common.chevronRight': {
    'className': 'fas fa-chevron-right',
    'family': 'fontawesome5',
    'fontAwesome5': 'chevron-right',
    'style': 'solid',
  },
  'common.close': {
    'className': 'fas fa-times',
    'family': 'fontawesome5',
    'fontAwesome5': 'times',
    'style': 'solid',
  },
  'common.delete': {
    'className': 'fas fa-trash-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'trash-alt',
    'style': 'solid',
  },
  'common.download': {
    'className': 'fas fa-download',
    'family': 'fontawesome5',
    'fontAwesome5': 'download',
    'style': 'solid',
  },
  'common.edit': {
    'className': 'fas fa-pen',
    'family': 'fontawesome5',
    'fontAwesome5': 'pen',
    'style': 'solid',
  },
  'common.error': {
    'className': 'fas fa-exclamation-circle',
    'family': 'fontawesome5',
    'fontAwesome5': 'exclamation-circle',
    'style': 'solid',
  },
  'common.externalLink': {
    'className': 'fas fa-external-link-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'external-link-alt',
    'style': 'solid',
  },
  'common.info': {
    'className': 'fas fa-info-circle',
    'family': 'fontawesome5',
    'fontAwesome5': 'info-circle',
    'style': 'solid',
  },
  'common.loading': {
    'className': 'fas fa-spinner',
    'family': 'fontawesome5',
    'fontAwesome5': 'spinner',
    'style': 'solid',
  },
  'common.minus': {
    'className': 'fas fa-minus',
    'family': 'fontawesome5',
    'fontAwesome5': 'minus',
    'style': 'solid',
  },
  'common.more': {
    'className': 'fas fa-ellipsis-h',
    'family': 'fontawesome5',
    'fontAwesome5': 'ellipsis-h',
    'style': 'solid',
  },
  'common.plus': {
    'className': 'fas fa-plus',
    'family': 'fontawesome5',
    'fontAwesome5': 'plus',
    'style': 'solid',
  },
  'common.question': {
    'className': 'fas fa-question-circle',
    'family': 'fontawesome5',
    'fontAwesome5': 'question-circle',
    'style': 'solid',
  },
  'common.refresh': {
    'className': 'fas fa-sync-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'sync-alt',
    'style': 'solid',
  },
  'common.save': {
    'className': 'fas fa-save',
    'family': 'fontawesome5',
    'fontAwesome5': 'save',
    'style': 'solid',
  },
  'common.search': {
    'className': 'fas fa-search',
    'family': 'fontawesome5',
    'fontAwesome5': 'search',
    'style': 'solid',
  },
  'common.selected': {
    'className': 'fas fa-check-circle',
    'family': 'fontawesome5',
    'fontAwesome5': 'check-circle',
    'style': 'solid',
  },
  'common.share': {
    'className': 'fas fa-share-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'share-alt',
    'style': 'solid',
  },
  'common.target': {
    'className': 'fas fa-crosshairs',
    'family': 'fontawesome5',
    'fontAwesome5': 'crosshairs',
    'style': 'solid',
  },
  'common.text': {
    'className': 'fas fa-font',
    'family': 'fontawesome5',
    'fontAwesome5': 'font',
    'style': 'solid',
  },
  'common.unselected': {
    'className': 'far fa-circle',
    'family': 'fontawesome5',
    'fontAwesome5': 'circle',
    'style': 'regular',
  },
  'common.warning': {
    'className': 'fas fa-exclamation-triangle',
    'family': 'fontawesome5',
    'fontAwesome5': 'exclamation-triangle',
    'style': 'solid',
  },
  'locations.contact': {
    'className': 'fas fa-address-card',
    'family': 'fontawesome5',
    'fontAwesome5': 'address-card',
    'style': 'solid',
  },
  'locations.directions': {
    'className': 'fas fa-directions',
    'family': 'fontawesome5',
    'fontAwesome5': 'directions',
    'style': 'solid',
  },
  'locations.distance': {
    'className': 'fas fa-route',
    'family': 'fontawesome5',
    'fontAwesome5': 'route',
    'style': 'solid',
  },
  'locations.hours': {
    'className': 'fas fa-clock',
    'family': 'fontawesome5',
    'fontAwesome5': 'clock',
    'style': 'solid',
  },
  'locations.list': {
    'className': 'fas fa-list',
    'family': 'fontawesome5',
    'fontAwesome5': 'list',
    'style': 'solid',
  },
  'locations.location': {
    'className': 'fas fa-map-marker-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'map-marker-alt',
    'style': 'solid',
  },
  'locations.map': {
    'className': 'fas fa-map-marked-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'map-marked-alt',
    'style': 'solid',
  },
  'locations.mine': {
    'className': 'fas fa-user-cog',
    'family': 'fontawesome5',
    'fontAwesome5': 'user-cog',
    'style': 'solid',
  },
  'locations.search': {
    'className': 'fas fa-search-location',
    'family': 'fontawesome5',
    'fontAwesome5': 'search-location',
    'style': 'solid',
  },
  'locations.website': {
    'className': 'fas fa-globe',
    'family': 'fontawesome5',
    'fontAwesome5': 'globe',
    'style': 'solid',
  },
  'match.addPlayers': {
    'className': 'fas fa-user-plus',
    'family': 'fontawesome5',
    'fontAwesome5': 'user-plus',
    'style': 'solid',
  },
  'match.balanceTeams': {
    'className': 'fas fa-balance-scale',
    'family': 'fontawesome5',
    'fontAwesome5': 'balance-scale',
    'style': 'solid',
  },
  'match.cancel': {
    'className': 'fas fa-ban',
    'family': 'fontawesome5',
    'fontAwesome5': 'ban',
    'style': 'solid',
  },
  'match.chevronForward': {
    'className': 'fas fa-angle-right',
    'family': 'fontawesome5',
    'fontAwesome5': 'angle-right',
    'style': 'solid',
  },
  'match.editPlayers': {
    'className': 'fas fa-users',
    'family': 'fontawesome5',
    'fontAwesome5': 'users',
    'style': 'solid',
  },
  'match.editResult': {
    'className': 'fas fa-clipboard-list',
    'family': 'fontawesome5',
    'fontAwesome5': 'clipboard-list',
    'style': 'solid',
  },
  'match.history': {
    'className': 'fas fa-history',
    'family': 'fontawesome5',
    'fontAwesome5': 'history',
    'style': 'solid',
  },
  'match.infinity': {
    'className': 'fas fa-infinity',
    'family': 'fontawesome5',
    'fontAwesome5': 'infinity',
    'style': 'solid',
  },
  'match.inviteDirect': {
    'className': 'fas fa-paper-plane',
    'family': 'fontawesome5',
    'fontAwesome5': 'paper-plane',
    'style': 'solid',
  },
  'match.inviteEmail': {
    'className': 'fas fa-envelope',
    'family': 'fontawesome5',
    'fontAwesome5': 'envelope',
    'style': 'solid',
  },
  'match.inviteFriends': {
    'className': 'fas fa-user-friends',
    'family': 'fontawesome5',
    'fontAwesome5': 'user-friends',
    'style': 'solid',
  },
  'match.inviteGuest': {
    'className': 'fas fa-user-plus',
    'family': 'fontawesome5',
    'fontAwesome5': 'user-plus',
    'style': 'solid',
  },
  'match.inviteLink': {
    'className': 'fas fa-link',
    'family': 'fontawesome5',
    'fontAwesome5': 'link',
    'style': 'solid',
  },
  'match.maxPlayers': {
    'className': 'fas fa-users',
    'family': 'fontawesome5',
    'fontAwesome5': 'users',
    'style': 'solid',
  },
  'match.notifications': {
    'className': 'fas fa-bell',
    'family': 'fontawesome5',
    'fontAwesome5': 'bell',
    'style': 'solid',
  },
  'match.notify.noResponse': {
    'className': 'fas fa-question-circle',
    'family': 'fontawesome5',
    'fontAwesome5': 'question-circle',
    'style': 'solid',
  },
  'match.notify.reserve': {
    'className': 'fas fa-user-clock',
    'family': 'fontawesome5',
    'fontAwesome5': 'user-clock',
    'style': 'solid',
  },
  'match.notify.sosContacts': {
    'className': 'fas fa-address-book',
    'family': 'fontawesome5',
    'fontAwesome5': 'address-book',
    'style': 'solid',
  },
  'match.notify.sosOther': {
    'className': 'fas fa-bullhorn',
    'family': 'fontawesome5',
    'fontAwesome5': 'bullhorn',
    'style': 'solid',
  },
  'match.rating': {
    'className': 'fas fa-trophy',
    'family': 'fontawesome5',
    'fontAwesome5': 'trophy',
    'style': 'solid',
  },
  'match.recurring': {
    'className': 'fas fa-sync-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'sync-alt',
    'style': 'solid',
  },
  'match.rulebook': {
    'className': 'fas fa-scroll',
    'family': 'fontawesome5',
    'fontAwesome5': 'scroll',
    'style': 'solid',
  },
  'match.seasons': {
    'className': 'fas fa-calendar-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'calendar-alt',
    'style': 'solid',
  },
  'match.settings': {
    'className': 'fas fa-cog',
    'family': 'fontawesome5',
    'fontAwesome5': 'cog',
    'style': 'solid',
  },
  'match.sliders': {
    'className': 'fas fa-sliders-h',
    'family': 'fontawesome5',
    'fontAwesome5': 'sliders-h',
    'style': 'solid',
  },
  'match.soccer': {
    'className': 'fas fa-futbol',
    'family': 'fontawesome5',
    'fontAwesome5': 'futbol',
    'style': 'solid',
  },
  'match.sos': {
    'className': 'fas fa-bolt',
    'family': 'fontawesome5',
    'fontAwesome5': 'bolt',
    'style': 'solid',
  },
  'match.stats': {
    'className': 'fas fa-chart-bar',
    'family': 'fontawesome5',
    'fontAwesome5': 'chart-bar',
    'style': 'solid',
  },
  'match.status.declined': {
    'className': 'fas fa-times',
    'family': 'fontawesome5',
    'fontAwesome5': 'times',
    'style': 'solid',
  },
  'match.status.firstTeam': {
    'className': 'fas fa-star',
    'family': 'fontawesome5',
    'fontAwesome5': 'star',
    'style': 'solid',
  },
  'match.status.notAnswered': {
    'className': 'fas fa-question',
    'family': 'fontawesome5',
    'fontAwesome5': 'question',
    'style': 'solid',
  },
  'match.status.notNotified': {
    'className': 'fas fa-bell-slash',
    'family': 'fontawesome5',
    'fontAwesome5': 'bell-slash',
    'style': 'solid',
  },
  'match.time': {
    'className': 'fas fa-clock',
    'family': 'fontawesome5',
    'fontAwesome5': 'clock',
    'style': 'solid',
  },
  'match.uncancel': {
    'className': 'fas fa-undo',
    'family': 'fontawesome5',
    'fontAwesome5': 'undo',
    'style': 'solid',
  },
  'match.visibility': {
    'className': 'fas fa-lock',
    'family': 'fontawesome5',
    'fontAwesome5': 'lock',
    'style': 'solid',
  },
  'match.visibilityOpen': {
    'className': 'fas fa-lock-open',
    'family': 'fontawesome5',
    'fontAwesome5': 'lock-open',
    'style': 'solid',
  },
  'navigation.chat': {
    'className': 'fas fa-comments',
    'family': 'fontawesome5',
    'fontAwesome5': 'comments',
    'style': 'solid',
  },
  'navigation.matches': {
    'className': 'fas fa-futbol',
    'family': 'fontawesome5',
    'fontAwesome5': 'futbol',
    'style': 'solid',
  },
  'navigation.more': {
    'className': 'fas fa-bars',
    'family': 'fontawesome5',
    'fontAwesome5': 'bars',
    'style': 'solid',
  },
  'navigation.notifications': {
    'className': 'fas fa-bell',
    'family': 'fontawesome5',
    'fontAwesome5': 'bell',
    'style': 'solid',
  },
  'notifications.readAll': {
    'className': 'fas fa-check-double',
    'family': 'fontawesome5',
    'fontAwesome5': 'check-double',
    'style': 'solid',
  },
  'notifications.type.candidateRequest': {
    'className': 'fas fa-user-plus',
    'family': 'fontawesome5',
    'fontAwesome5': 'user-plus',
    'style': 'solid',
  },
  'notifications.type.emailVerification': {
    'className': 'fas fa-envelope',
    'family': 'fontawesome5',
    'fontAwesome5': 'envelope',
    'style': 'solid',
  },
  'notifications.type.lowPlayerCount': {
    'className': 'fas fa-exclamation-triangle',
    'family': 'fontawesome5',
    'fontAwesome5': 'exclamation-triangle',
    'style': 'solid',
  },
  'notifications.type.matchCanceled': {
    'className': 'fas fa-calendar-times',
    'family': 'fontawesome5',
    'fontAwesome5': 'calendar-times',
    'style': 'solid',
  },
  'notifications.type.matchFull': {
    'className': 'fas fa-users',
    'family': 'fontawesome5',
    'fontAwesome5': 'users',
    'style': 'solid',
  },
  'notifications.type.matchInvite': {
    'className': 'fas fa-calendar-plus',
    'family': 'fontawesome5',
    'fontAwesome5': 'calendar-plus',
    'style': 'solid',
  },
  'notifications.type.matchLocationChanged': {
    'className': 'fas fa-map-marker-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'map-marker-alt',
    'style': 'solid',
  },
  'notifications.type.matchResponseReminder': {
    'className': 'fas fa-clock',
    'family': 'fontawesome5',
    'fontAwesome5': 'clock',
    'style': 'solid',
  },
  'notifications.type.matchTimeChanged': {
    'className': 'fas fa-calendar-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'calendar-alt',
    'style': 'solid',
  },
  'notifications.type.missingResult': {
    'className': 'fas fa-clipboard-list',
    'family': 'fontawesome5',
    'fontAwesome5': 'clipboard-list',
    'style': 'solid',
  },
  'notifications.type.noActiveMatches': {
    'className': 'fas fa-futbol',
    'family': 'fontawesome5',
    'fontAwesome5': 'futbol',
    'style': 'solid',
  },
  'notifications.type.pendingInvites': {
    'className': 'fas fa-paper-plane',
    'family': 'fontawesome5',
    'fontAwesome5': 'paper-plane',
    'style': 'solid',
  },
  'notifications.type.profileLocationMissing': {
    'className': 'fas fa-map-marker-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'map-marker-alt',
    'style': 'solid',
  },
  'notifications.type.publicRsvp': {
    'className': 'fas fa-link',
    'family': 'fontawesome5',
    'fontAwesome5': 'link',
    'style': 'solid',
  },
  'notifications.type.ratingReview': {
    'className': 'fas fa-star',
    'family': 'fontawesome5',
    'fontAwesome5': 'star',
    'style': 'solid',
  },
  'notifications.type.rulebookReminder': {
    'className': 'fas fa-scroll',
    'family': 'fontawesome5',
    'fontAwesome5': 'scroll',
    'style': 'solid',
  },
  'notifications.type.sosRecommended': {
    'className': 'fas fa-bullhorn',
    'family': 'fontawesome5',
    'fontAwesome5': 'bullhorn',
    'style': 'solid',
  },
  'player.add': {
    'className': 'fas fa-user-plus',
    'family': 'fontawesome5',
    'fontAwesome5': 'user-plus',
    'style': 'solid',
  },
  'player.addressCard': {
    'className': 'fas fa-address-card',
    'family': 'fontawesome5',
    'fontAwesome5': 'address-card',
    'style': 'solid',
  },
  'player.camera': {
    'className': 'fas fa-camera',
    'family': 'fontawesome5',
    'fontAwesome5': 'camera',
    'style': 'solid',
  },
  'player.claim': {
    'className': 'fas fa-user-check',
    'family': 'fontawesome5',
    'fontAwesome5': 'user-check',
    'style': 'solid',
  },
  'player.email': {
    'className': 'fas fa-envelope',
    'family': 'fontawesome5',
    'fontAwesome5': 'envelope',
    'style': 'solid',
  },
  'player.image': {
    'className': 'fas fa-image',
    'family': 'fontawesome5',
    'fontAwesome5': 'image',
    'style': 'solid',
  },
  'player.notifications': {
    'className': 'fas fa-bell',
    'family': 'fontawesome5',
    'fontAwesome5': 'bell',
    'style': 'solid',
  },
  'player.phone': {
    'className': 'fas fa-phone',
    'family': 'fontawesome5',
    'fontAwesome5': 'phone',
    'style': 'solid',
  },
  'player.profile': {
    'className': 'fas fa-user',
    'family': 'fontawesome5',
    'fontAwesome5': 'user',
    'style': 'solid',
  },
  'player.rating': {
    'className': 'fas fa-star',
    'family': 'fontawesome5',
    'fontAwesome5': 'star',
    'style': 'solid',
  },
  'player.security': {
    'className': 'fas fa-shield-alt',
    'family': 'fontawesome5',
    'fontAwesome5': 'shield-alt',
    'style': 'solid',
  },
  'player.team': {
    'className': 'fas fa-tshirt',
    'family': 'fontawesome5',
    'fontAwesome5': 'tshirt',
    'style': 'solid',
  },
  'player.unavailable': {
    'className': 'fas fa-user-times',
    'family': 'fontawesome5',
    'fontAwesome5': 'user-times',
    'style': 'solid',
  },
  'publicInvite.chat': {
    'className': 'fas fa-comments',
    'family': 'fontawesome5',
    'fontAwesome5': 'comments',
    'style': 'solid',
  },
  'publicInvite.profileNudge': {
    'className': 'fas fa-user-plus',
    'family': 'fontawesome5',
    'fontAwesome5': 'user-plus',
    'style': 'solid',
  },
};

export const NOGOSH_ICON_SIZES: Record<NogoshIconSizeName, number> = {
  'button': 20,
  'compact': 16,
  'emptyState': 44,
  'inline': 14,
  'micro': 10,
  'prominent': 28,
  'row': 18,
  'state': 50,
  'toolbar': 24,
};

export function nogoshIconClass(name: NogoshIconName): string {
  return NOGOSH_ICONS[name].className;
}

export function nogoshIconSizeClass(name: NogoshIconSizeName): string {
  return 'nogosh-icon-size-' + name;
}
